// extracted by mini-css-extract-plugin
export var body = "_ch-0";
export var sectionHeader = "_ch-4";
export var shortcutColumns = "_ch-2";
export var shortcutList = "_ch-1";
export var shortcutSection = "_ch-3";